// removed by extract-text-webpack-plugin
module.exports = {"shop":"shop__6BwVe","shop_item":"shop_item__3fkpv","shop_item_media":"shop_item_media__3kKVs","shop_item_media_image":"shop_item_media_image__3WLYh","shop_item_media_video":"shop_item_media_video__1VTDs"};


//////////////////
// WEBPACK FOOTER
// ./components/Shop/Shop.scss
// module id = M/Rh
// module chunks = 0